import {
  SET_WHITE_LIST,
  SET_WHITE_LIST_SEARCH_PARAMS,
  SET_USER_TASK_VALIDITY_PERIOD_LIST,
  SET_LOADING_USER_TASK_VALIDITY_PERIOD,
  SET_USER_TASK_VALIDITY_PERIOD_PAGE_NUM,
  SET_USER_TASK_VALIDITY_PERIOD_PAGE_SIZE,
  SET_USER_TASK_VALIDITY_PERIOD_TOTAL,
  SET_USER_TASK_VALIDITY_PERIOD_QUERY,
} from './mutation-types'
import api from '@/api'
import _ from 'lodash'

const initQuery = () => ({
  userId: '',
  userName: '',
  status: '',
  retentionDays: '',
  pageSize: 50,
  pageNum: 1,
})
const state = {
  list: [],
  pageNum: 1,
  pageSize: 30,
  total: 0,
  userTaskValidityPeriod: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
  },
  loadingUserTaskValidityPeriod: false,
}

const mutations = {
  [SET_WHITE_LIST](state, payload) {
    state.list = payload
  },
  [SET_WHITE_LIST_SEARCH_PARAMS](state, payload) {
    const { name, value } = payload
    state[name] = value
  },
  [SET_USER_TASK_VALIDITY_PERIOD_LIST](state, payload) {
    state.userTaskValidityPeriod.list = payload
  },
  [SET_LOADING_USER_TASK_VALIDITY_PERIOD](state, payload) {
    state.loadingUserTaskValidityPeriod = payload
  },
  [SET_USER_TASK_VALIDITY_PERIOD_PAGE_NUM](state, payload) {
    state.userTaskValidityPeriod.query.pageNum = payload
  },
  [SET_USER_TASK_VALIDITY_PERIOD_PAGE_SIZE](state, payload) {
    state.userTaskValidityPeriod.query.pageSize = payload
  },
  [SET_USER_TASK_VALIDITY_PERIOD_TOTAL](state, payload) {
    state.userTaskValidityPeriod.listPageTotal = payload
  },
  [SET_USER_TASK_VALIDITY_PERIOD_QUERY](state, payload) {
    state.userTaskValidityPeriod.query = {
      ...state.userTaskValidityPeriod.query,
      ...payload,
    }
  },
}

const actions = {
  // 用户存储白名单列表
  async getCleanListForUser({ commit, state }, payload) {
    if (payload && payload.userId) {
      commit(SET_WHITE_LIST_SEARCH_PARAMS, { name: 'pageNum', value: 1 })
    }
    let res = await api.storageApi.getCleanListForUser({
      pageNum: state.pageNum,
      pageSize: state.pageSize,
      ...payload,
    })
    commit(SET_WHITE_LIST, res.data.items)
    commit(SET_WHITE_LIST_SEARCH_PARAMS, { name: 'total', value: res.data.total })
  },
  // 新增白名单
  async addUserForCleanList({ dispatch }, payload) {
    let data = await api.storageApi.addUserForCleanList(payload)
    if (data.code === 200) {
      dispatch('getCleanListForUser')
    }
    return data
  },
  // 删除白名单
  async deleteUserForCleanList({ dispatch }, payload) {
    let data = await api.storageApi.deleteUserForCleanList(payload)
    if (data.code === 200) {
      dispatch('getCleanListForUser')
    }
    return data
  },
  // 导出白名单
  async exportCleanListForUser(_, payload) {
    let data = await api.storageApi.exportCleanListForUser(payload)
    return data
  },
  // 清空存储
  async deleteStorageListCache({ dispatch }, payload) {
    let data = await api.storageApi.deleteStorageListCache(payload)
    return data
  },
  // 新增input清理规则
  async addInputUserForCleanList({ state }, payload) {
    const res = await api.storageApi.addInputUserForCleanList(payload)
    return res
  },
  // 新增output清理规则
  async addOutputUserForCleanList({ state }, payload) {
    const res = await api.storageApi.addOutputUserForCleanList(payload)
    return res
  },
  // 编辑清理规则
  async updateUserForCleanList({ state }, payload) {
    const res = await api.storageApi.updateUserForCleanList(payload)
    return res
  },
  // 查询用户任务存储规则
  async queryUserTaskStorageRule({ commit, state }) {
    try {
      let query = {}
      _.forIn(state.userTaskValidityPeriod.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
      }
      commit(SET_LOADING_USER_TASK_VALIDITY_PERIOD, true)
      const { data: {items, total} } = await api.storageApi.queryUserTaskStorageRule(params)
      commit(SET_LOADING_USER_TASK_VALIDITY_PERIOD, false)
      commit(SET_USER_TASK_VALIDITY_PERIOD_LIST, items)
      commit(SET_USER_TASK_VALIDITY_PERIOD_TOTAL, total)
      return items
    } catch (error) {
      commit(SET_LOADING_USER_TASK_VALIDITY_PERIOD, false)
      commit(SET_USER_TASK_VALIDITY_PERIOD_LIST, [])
      commit(SET_USER_TASK_VALIDITY_PERIOD_TOTAL, 0)
      return null
    }
  },
  searchUserTaskStorageRule({commit, dispatch}, payload) {
    commit(SET_USER_TASK_VALIDITY_PERIOD_PAGE_NUM, payload.pageNum)
    dispatch('queryUserTaskStorageRule')
  },
  async initUserTaskStorageRule ({dispatch}) {
    await dispatch('changeUserTaskStorageRuleQuery', initQuery())
    await dispatch('queryUserTaskStorageRule')
  },
  changeUserTaskStorageRuleQuery ({commit, dispatch}, payload) {
    commit(SET_USER_TASK_VALIDITY_PERIOD_QUERY, payload)
  },
  changeUserTaskStorageRulePageNum ({commit, dispatch}, payload) {
    commit(SET_USER_TASK_VALIDITY_PERIOD_PAGE_NUM, payload.currentPage)
    if (payload.refresh) dispatch('queryUserTaskStorageRule')
  },
  changeUserTaskStorageRulePageSize ({commit, dispatch}, payload) {
    commit(SET_USER_TASK_VALIDITY_PERIOD_PAGE_SIZE, payload.pageSize)
    dispatch('changeUserTaskStorageRulePageNum', {currentPage: 1})
  },
  // 新增用户任务存储规则
  async addUserTaskStorageRule({ state }, payload) {
    const res = await api.storageApi.addUserTaskStorageRule(payload)
    return res
  },
  // 编辑用户任务存储规则
  async updateUserTaskStorageRule({ state }, payload) {
    const res = await api.storageApi.updateUserTaskStorageRule(payload)
    return res
  },
  // 删除用户任务存储规则
  async deleteUserTaskStorageRule({ state }, payload) {
    const res = await api.storageApi.deleteUserTaskStorageRule(payload)
    return res
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
